exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contents.about{\n  padding: 0 5%;\n  height: 100%;\n  /* border: 1px solid black; */\n  width: 100%;\n  overflow: scroll;\n}\n.contents.about p {\n  text-align: left;\n}\n#pic2 {\n  width: 35%;\n}\n#about {\n  height: 100vh;\n  min-height: 100vh;\n  display: -webkit-flex;\n  display: flex;\n  -webkit-flex-direction: row;\n          flex-direction: row;\n  -webkit-justify-content: center;\n          justify-content: center;\n  /* outline: 1px solid orange; */\n  width: 100%;\n}\n#about img {\n  width: 15%;\n}\n", ""]);

// exports
